import { createSelector } from "@ngrx/store";
import { AppState } from "..";
import { AuthUserState } from "./auth-user.reducers";
import {AuthState} from '@feature-module/login/redux/reducer/login.reducer';

export const selectFeature = (appState: AppState) => appState.loggedUser;
export const selectFeatureAuth = (appState: AppState) => appState.auth;

export const selectAuthUser = createSelector(
  selectFeature,
  (state: AuthUserState) => state.user
);
export const isSupervisor = createSelector(
  selectFeatureAuth,
  (state: AuthState) => state.isSupervisor
)
